import { hasPermission } from '@/features/auth/lib/permissions';
import { useAppSelector } from '@/hooks/useAppSelector';

export function useHasPermission(permission: string | string[]) {
  return useAppSelector(state => hasPermission(state.auth.permissions, permission));
}
